import { Typography } from '@mui/material';
import { theme } from '@theguarantors/tg-package-material-ui';
import RenterInviteDrawerForm from './RenterInviteDrawerForm';
import { useRenterInviteController } from './useRenterInvite.controller';

export type RenterInviteDrawerFormContentProps = {
  onSuccess?: () => void;
};

const RenterInviteDrawerFormContent = ({ onSuccess }: RenterInviteDrawerFormContentProps) => {
  const { user, errorMsg, isSmbRenterInvites, useNewForm, customCoverageDisabled, onSubmit } =
    useRenterInviteController({ onSuccess });

  return (
    <>
      <Typography
        mb={3}
        letterSpacing={0}
        sx={{
          fontSize: '16px !important',
          [theme.breakpoints.down('md')]: {
            fontSize: '14px !important',
            lineHeight: '22px',
          },
        }}
      >
        Please fill out your applicant's information below, and we will send them an invitation to
        apply using the email address provided.
      </Typography>
      <RenterInviteDrawerForm
        user={user}
        onSubmit={onSubmit}
        errorMsg={errorMsg}
        newCoveragesEnabled={useNewForm}
        customCoverageDisabled={customCoverageDisabled}
        isSmbRenterInvites={isSmbRenterInvites}
      />
    </>
  );
};

export default RenterInviteDrawerFormContent;
